const getCurrentCompany = (companies, companyId) => {
    const company = companies?.find(c => c.id === companyId);
    return company;
}

export default getCurrentCompany;